module.exports = __webpack_public_path__ + "60496f8c58917c7e804d370df5770eaa.MP3";